import { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ContactModal from "./components/ContactModal";
import Home from "./pages/Home";
import Products from "./pages/Products";
import About from "./pages/About";
import Careers from "./pages/Careers";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/toaster";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Use legacy scrollTo signature for best cross-mobile support (avoids 'instant' fallback)
    window.scrollTo(0, 0);
    // Clear any leftover body scroll locks (e.g. from rapidly closed modals)
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
  }, [pathname]);
  return null;
}

function PublicLayout() {
  const [contactOpen, setContactOpen] = useState(false);
  const { pathname } = useLocation();
  const isProducts = pathname.startsWith('/products');
  const title = isProducts ? 'Request a Demo' : 'Get in Touch';
  const subtitle = isProducts
    ? "See the IronVision GRC Platform in action. We'll reach out within 24 hours."
    : "Tell us about your security needs and we'll be in touch within 24 hours.";
  const source = isProducts ? 'demo' : 'contact';

  const openContact = () => setContactOpen(true);

  return (
    <div className="min-h-screen bg-[#0a0e1a] text-white">
      <Navbar onContact={openContact} />
      <main>
        <Routes>
          <Route path="/" element={<Home onContact={openContact} />} />
          <Route path="/products" element={<Products onContact={openContact} />} />
          <Route path="/about" element={<About onContact={openContact} />} />
          <Route path="/careers" element={<Careers onContact={openContact} />} />
        </Routes>
      </main>
      <Footer />
      <ContactModal open={contactOpen} onOpenChange={setContactOpen} title={title} subtitle={subtitle} source={source} />
    </div>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="/admin/*" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="/*" element={<PublicLayout />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <AppRoutes />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
